import { HTTP_TOKEN } from "./http";

export const getWithdraws = (params) => {
  return HTTP_TOKEN.get("withdraw", { params }).then((result) => {
    return result.data;
  });
};

export const getWithdraw = (withdraw_id) => {
  return HTTP_TOKEN.get(`withdraw/${withdraw_id}`).then((result) => {
    return result.data;
  });
};

export const createWithdraw = (data) => {
  return HTTP_TOKEN.post("withdraw", data).then((result) => {
    return result.data;
  });
};


export const updateWithdraw = (withdraw_id, data) => {
  return HTTP_TOKEN.put(`withdraw/${withdraw_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeWithdraw = (withdraw_id) => {
  return HTTP_TOKEN.delete(`withdraw/${withdraw_id}`).then((result) => {
    return result.data;
  });
};
